import { IdnowProviderDetailsErrorReason } from '@repo/api-kit/queries/due-diligence/kyc';
import type { IdNowErrorKeys } from '#providers/components/idnow/error';

export function toIdNowErrorKey(
  reason: (typeof IdnowProviderDetailsErrorReason)[keyof typeof IdnowProviderDetailsErrorReason]
) {
  if (reason === IdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED) {
    return undefined;
  }
  // oxlint-disable-next-line typescript/consistent-type-assertions
  return reason.toUpperCase() as IdNowErrorKeys;
}
